import React, { Fragment } from 'react'
import {
  TextField,
  MenuItem,
  StandardTextFieldProps,
  OutlinedTextFieldProps,
  FilledTextFieldProps
} from '@mui/material'

type Variant = 'outlined' | 'standard' | 'filled'

interface GenericMultiselectBaseProps<T> {
  initialValues: T[] // array de datos para llenar DDL
  title: string // nombre al pedir selección
  valueKey: keyof T // campo db para asignar valor a cada selección
  required?: boolean
  excludedOptions?: any[] // Array con valores a excluir
  variant?: Variant
}

type GenericMultiselectProps<T> = GenericMultiselectBaseProps<T> &
  (StandardTextFieldProps | OutlinedTextFieldProps | FilledTextFieldProps)

export interface GenericData {
  [key: string]: any
}

export const GenericDLL = <T extends GenericData>({
  initialValues,
  variant = 'outlined',
  title = '',
  valueKey,
  excludedOptions = [],
  ...otherProps
}: GenericMultiselectProps<T>) => {
  // saca valores excluidos
  const filteredValues =
    initialValues?.filter(
      (option) => !excludedOptions.includes(option[valueKey])
    ) || []

  return (
    <Fragment>
      <TextField
        variant={variant}
        id={valueKey as string}
        select
        {...otherProps}
      >
        <MenuItem key={-1} value={-1}>
          {`Seleccionar ${title}...`}
        </MenuItem>
        {filteredValues.map((option) => (
          <MenuItem key={option[valueKey]} value={option[valueKey]}>
            {option[otherProps.name || '']}
          </MenuItem>
        ))}
      </TextField>
    </Fragment>
  )
}
